import {BaseComparisonOperator} from "../base-comparison-operator";

export class IsFalsyOperator extends BaseComparisonOperator {
  compare(value1: unknown, value2: unknown): boolean {
    return !((value1 || '').toString() === (value2 || '').toString());
  }
}
